import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../atoms/buttons/enums.js';
import { isRTL } from '../../../utilities/dom-helpers/index.js';

/* eslint-disable import/no-absolute-path */
const renderInfographicLayout = (ctx) => x `<div class="header"><slot name="headline"></slot></div><div class="swiper"><div class="swiper-wrapper" dir="${ctx.rtl || isRTL() ? 'rtl' : 'ltr'}"></div><slot name="slide-container"></slot></div><div class="swiper-pagination"></div><carousel-navigation ?rtl="${ctx.rtl || isRTL() ? 'rtl' : ''}" nextText="${ctx.nextText}" darkBg previousText="${ctx.previousText}"></carousel-navigation>`;

export { renderInfographicLayout };
